module.exports = __webpack_public_path__ + "img/asuka_gaikokujin.33c1541f.jpg";